import { createBaseRecord } from "../records";
import { createHeaders, getRawRows, getSheetRows, normalizeText } from "../workbook";

export const STARTRACK = "StarTrack";

const REQUIRED_HEADERS = [
  "consignment id",
  "raw performance stop clock",
  "sp failure type",
  "sp expected delivery date",
  "stop the clock date",
];

export const badgeClass = "bg-orange-100 text-orange-700 ring-orange-200";

export function detect(workbook) {
  const sheetNames = workbook.SheetNames || [];
  const firstRows = getRawRows(workbook.Sheets[sheetNames[0]]);
  const headers = createHeaders(firstRows[0] || []);

  return REQUIRED_HEADERS.every((header) => headers.includes(header));
}

function parseRows(rows) {
  return rows.map((row, index) => {
    const failureType = normalizeText(row["sp failure type"]);
    const forceMajeureReason = normalizeText(row["last force majeure reason"]);
    const stopClockStatus = normalizeText(row["raw performance stop clock"]);

    let automatedKpiHit = false;
    let carrierKpiExplanation = "";
    let ruleApplied = "Late or non-success StarTrack consignment";

    if (failureType.toLowerCase() === "success") {
      automatedKpiHit = true;
      ruleApplied = "Success in StarTrack";
    } else if (
      failureType.toLowerCase().includes("force majeure") &&
      failureType.toLowerCase().includes("justified")
    ) {
      automatedKpiHit = true;
      carrierKpiExplanation = [failureType, forceMajeureReason]
        .filter(Boolean)
        .join(" : ");
      ruleApplied = "Force majeure justified in StarTrack";
    } else {
      automatedKpiHit = false;
      carrierKpiExplanation = [stopClockStatus, failureType]
        .filter(Boolean)
        .join(" : ");
    }

    return createBaseRecord({
      carrier: STARTRACK,
      sourceSheet: "sheet1",
      rowNumber: index + 2,
      consignmentId: row["consignment id"],
      despatchDate: row["start the clock date"],
      eta: row["sp expected delivery date"],
      completedDate: row["stop the clock date"],
      automatedKpiHit,
      carrierKpiExplanation,
      ruleApplied,
      rawStatus: stopClockStatus,
      forceMajeureReason,
    });
  });
}

export function parse(workbook) {
  const firstSheet = workbook.SheetNames[0];
  const rows = getSheetRows(workbook.Sheets[firstSheet], 0);

  return {
    records: parseRows(rows),
    sheetSummaries: [{ name: firstSheet, rowCount: rows.length }],
  };
}
